import { LazyModule, LazyImport } from 'owa-bundling';
var lazyModule = new LazyModule(function () {
    return System.import(
    /* webpackChunkName: "LandmarksNavigation", webpackPrefetch: true */ './lazyIndex');
});
export var lazyAddLandmarkKeyboardNavigation = new LazyImport(lazyModule, function (m) { return m.addLandmarkKeyboardNavigation; });
//# sourceMappingURL=index.js.map